import { ENV_ANDROID } from '../../const';
import { env } from '../../getNativeInfo';
import { prepareApi } from '../../utils';
prepareApi(['bcz_system']);
/**
 * 获取系统状态栏高度（单位：像素）
 *
 * *Android ONLY*
 */
export function getStatusBarHeight() {
  try {
    if (env === ENV_ANDROID) {
      return window.bcz_system.getStatusBarHeight();
    } else {
      throw new Error();
    }
  } catch (e) {
    return undefined;
  }
}